import { Dispatch, SetStateAction } from 'react';
import { useMutation } from 'react-query';

import { updateIndustryRoute } from '@features/industry';
import axiosInstance from '@server/axiosInstance';

type UseUpdateIndustryProps = {
  setAlertText?: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useUpdateIndustry = ({
  setAlertText = () => {},
  onSuccess = () => {},
}: UseUpdateIndustryProps) => {
  const errorMessage = 'Sorry, something went wrong';

  const { mutate: updateIndustryMutation, isLoading: isUpdateIndustryLoading} =  useMutation({
    mutationFn: (variables: { industry_id: number }) =>
      axiosInstance
        .post(updateIndustryRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setAlertText(data.message);
      } else {
        setAlertText('');
        onSuccess();
      }
    },
    onError: () => {
      setAlertText(errorMessage);
    },
  });

  return {
    updateIndustryMutation,
    isUpdateIndustryLoading
  };
};
